import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import { useWebSiteModel } from "../webSiteModel";

export const DataBox = () => {
	const {
		serDetailDrawer
	} = useWebSiteModel();

	const action = <>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => serDetailDrawer({ visible: true, mode: "add" })}
		>新增</Button>

	</>;
	return (
		<YhBox title=" " style={{ marginTop: "20px" }} action={action}>
			<DataTable />
		</YhBox>
	)
}